import styled from 'styled-components'

export const Button = styled.button`
  cursor: pointer;
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  padding: 1px;
  border: 0;
  text-transform: uppercase;
  width: 150px;
  border-radius: 3em;
  color: white;
  background-color: #CB2828;
`

export const Logo = styled.img`
  height: 50px;
  margin-left: 10px;
`
export const UserLogo = styled.img`
  height: 35px;
`